import { render, staticRenderFns } from "./LTaglist.vue?vue&type=template&id=056618b4&scoped=true"
import script from "./LTaglist.vue?vue&type=script&lang=ts"
export * from "./LTaglist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056618b4",
  null
  
)

export default component.exports